import React, { useEffect, useState } from 'react'
import { CssBaseline } from '@material-ui/core'
import LOGO_URL from '../../assets/logo.svg'
import LOGO_LIGHT_URL from '../../assets/logoLight.svg'
import usePublicWrapperStyles from './public-wrapper.styles'
import { Footer } from '../custom/footer'

const DEFAULT_BANNER_SIZE = {
    WIDTH: 1468,
    HEIGHT: 461
}

interface PublicWrapperProps {
    children?: any
    title?: string
    bannerImgUrlRectangle?: string
    bannerImgUrlRectangleRocket?: string
    bannerSubmit?: string
    bannerNext?: string
    bannerEclipse?: string
    buttonLogout?: string
    contactInfo?: JSX.Element
    bannerImgUrlWomanWorkingOnlaptop?: string
    secondaryContent?: JSX.Element
    heading?: JSX.Element
    heading1?: JSX.Element
    heading2?: JSX.Element
    heading3?: JSX.Element
    heading4?: JSX.Element
    heading5?: JSX.Element
    heading6?: JSX.Element
    additionalContent?: JSX.Element
    content?: JSX.Element
    content2?: JSX.Element
    content3?: JSX.Element
    content4?: JSX.Element
    displaySecondaryOnMobile?: boolean
    displayPrivacyPolicyFooter?: boolean
    backgroundClass?: any
    contentWrapperClass?: any
    darkTheme?: boolean
    footerData?: JSX.Element
}

const PublicWrapper: React.FC<PublicWrapperProps> = ({
    children,
    title,
    bannerImgUrlRectangle,
    bannerImgUrlRectangleRocket,
    bannerSubmit,
    bannerNext,
    buttonLogout,
    bannerEclipse,
    bannerImgUrlWomanWorkingOnlaptop,
    displaySecondaryOnMobile,
    displayPrivacyPolicyFooter = true,
    backgroundClass,
    darkTheme,
    content,
    contentWrapperClass,
    footerData
}) => {
    const [bannerHeight, setBannerHeight] = useState(0)
    const classes = usePublicWrapperStyles({
        bannerImgUrlRectangle,
        bannerImgUrlRectangleRocket,
        buttonLogout,
        bannerSubmit,
        bannerNext,
        bannerEclipse,
        bannerImgUrlWomanWorkingOnlaptop,
        displaySecondaryOnMobile,
        bannerImageHeight: bannerHeight
    })

    useEffect(() => {
        const handleResize = (): void => {
            const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            const newHeight = (DEFAULT_BANNER_SIZE.HEIGHT / DEFAULT_BANNER_SIZE.WIDTH) * viewportWidth

            setBannerHeight(newHeight)
        }

        window.addEventListener('resize', handleResize)
        handleResize()

        return (): void => {
            window.removeEventListener('resize', handleResize)
        }
    }, []) // eslint-disable-line

    const getBackgroundImage = () => {
        let url
        if (bannerImgUrlRectangle) {
            url = bannerImgUrlRectangle
        } else if (bannerImgUrlRectangleRocket) {
            url = bannerImgUrlRectangleRocket
        }
        if (url) {
            return `url(${url})`
        }
        return 'none'
    }

    return (
        <>
            <CssBaseline />
            <div className={`${classes.root}  ${backgroundClass}`} style={{ backgroundImage: getBackgroundImage() }}>
                <header className={classes.header}>
                    <img className={classes.logo} src={darkTheme ? LOGO_LIGHT_URL : LOGO_URL} alt="First Citizens Bank" />
                </header>
                <div className={`${classes.content} ${contentWrapperClass ?? ''}`}>
                    {content}
                    {children}
                </div>
                {displayPrivacyPolicyFooter && <Footer footerData={footerData} />}
            </div>
        </>
    )
}

export default PublicWrapper
